var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrcaresult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0B4770;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M752.2,226.1H639.9v-26.5c0-7.6-6.2-13.8-13.8-13.8h-65.7c0.5-2.9,0.7-6,0.7-9c0-33.7-27.4-61.1-61.1-61.1 c-33.7,0-61.1,27.4-61.1,61.1c0,3,0.2,6,0.7,9h-65.7c-7.6,0-13.8,6.2-13.8,13.8v26.5H247.8c-7.6,0-13.8,6.2-13.8,13.8v630.5 c0,7.6,6.2,13.8,13.8,13.8h504.4c7.6,0,13.8-6.2,13.8-13.8V239.9C766,232.3,759.8,226.1,752.2,226.1z M387.7,226.1v-12.7h71.1 c4.9,0,9.4-2.6,11.9-6.8c2.5-4.2,2.6-9.4,0.2-13.7c-2.9-5.2-4.4-10.6-4.4-16.1c0-18.5,15-33.5,33.5-33.5c18.5,0,33.5,15,33.5,33.5 c0,5.5-1.5,10.9-4.4,16.1c-2.4,4.3-2.3,9.5,0.2,13.7c2.5,4.2,7,6.8,11.9,6.8h71.1v12.7v22.8H387.7V226.1z M738.4,856.6H261.6 V253.7h98.5v9c0,7.6,6.2,13.8,13.8,13.8h252.2c7.6,0,13.8-6.2,13.8-13.8v-9h98.5V856.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M417.4,471.3h-78.8c-7.6,0-13.8-6.2-13.8-13.8v-78.8c0-7.6,6.2-13.8,13.8-13.8h78.8c7.6,0,13.8,6.2,13.8,13.8 v78.8C431.2,465.1,425,471.3,417.4,471.3z M352.4,443.7h51.2v-51.2h-51.2V443.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M661.4,431.9H488c-7.6,0-13.8-6.2-13.8-13.8c0-7.6,6.2-13.8,13.8-13.8h173.4c7.6,0,13.8,6.2,13.8,13.8 C675.2,425.7,669,431.9,661.4,431.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M417.4,621.1h-78.8c-7.6,0-13.8-6.2-13.8-13.8v-78.8c0-7.6,6.2-13.8,13.8-13.8h78.8c7.6,0,13.8,6.2,13.8,13.8 v78.8C431.2,615,425,621.1,417.4,621.1z M352.4,593.5h51.2v-51.2h-51.2V593.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M661.4,581.7H488c-7.6,0-13.8-6.2-13.8-13.8c0-7.6,6.2-13.8,13.8-13.8h173.4c7.6,0,13.8,6.2,13.8,13.8 C675.2,575.5,669,581.7,661.4,581.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M417.4,770.9h-78.8c-7.6,0-13.8-6.2-13.8-13.8v-78.8c0-7.6,6.2-13.8,13.8-13.8h78.8c7.6,0,13.8,6.2,13.8,13.8 v78.8C431.2,764.7,425,770.9,417.4,770.9z M352.4,743.3h51.2v-51.2h-51.2V743.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M661.4,731.5H488c-7.6,0-13.8-6.2-13.8-13.8c0-7.6,6.2-13.8,13.8-13.8h173.4c7.6,0,13.8,6.2,13.8,13.8 C675.2,725.3,669,731.5,661.4,731.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrcaresult);
export default __webpack_public_path__ + "static/media/brcaresult.bdaf6579909308db3cad2b7dc39e81d3.svg";
export { ForwardRef as ReactComponent };